import {Component} from '@angular/core';
import { Platform } from 'ionic-angular';

import {BarcodeScanner} from '@ionic-native/barcode-scanner';

import {User} from '../../model/user';

import { GuiProvider } from '../../providers/gui.provider';
import { UserProvider } from '../../providers/user.provider';


@Component({
  templateUrl: 'login.html'
})
export class LoginPage {

	user: User = <any>{};
	inputUsername: string = '';
	inputPassword: string = '';

	constructor(
		private platform: Platform,
		private barcodeScanner: BarcodeScanner,
		private guiProvider : GuiProvider,
		private userProvider : UserProvider
	) { }

	ionViewWillEnter() {
		this.user = this.userProvider.user;
	}

	logout() {
		this.userProvider.logout();
		this.user = this.userProvider.user;
	}

	isCordova() {
		return !!window["cordova"];
	}

	scan() {
		this.platform.ready().then(() => {
			this.barcodeScanner.scan().then(barcodeData => {
				this.userProvider.loginFromUrl(barcodeData.text);
				this.user = this.userProvider.user;
			}, (err) => {
				this.guiProvider.showAlert('Fehlgeschlagen',
					'Das Lesen des QR-Codes schlug fehl. Bitte geben Sie die Zugangsdaten von Hand ein. FEHLER: ' + err);
			});
		});
	}

	loginFromInput() {
		if (this.inputUsername.length == 0)
			this.guiProvider.showAlert('Fehler', 'Bitte Benutzername eingeben.');
		else if (this.inputPassword.length == 0)
			this.guiProvider.showAlert('Fehler', 'Bitte Passwort eingeben.');
		else if (false == this.userProvider.checkLogin(this.inputUsername, this.inputPassword))
			this.guiProvider.showAlert('Fehler', 'Bitte überprüfen Sie das Passwort.');
		else {
			this.userProvider.login(this.inputUsername, this.inputPassword);
			this.guiProvider.showAlertAndPop('Angemeldet',
				'Sie sind jetzt angemeldet und können Sterbefälle übermitteln.');
		}
	}

}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts